import React, { Component, Fragment } from 'react';
import { Card, BreadCrumb } from '../../components';
import { Translate } from '../../contexts/Language';
import { CurrencyEdit } from '../../components/CurrencyEdit';
import { Service } from '../../services';
import { Config } from '../../config';


export class CurrencySettings extends Component {
    constructor(props) {
        super(props)

        this.state = {
            currenyRates: []
        }
    }

    componentDidMount() {

        Config.utilities.loadingFetch();

        Service.User.GetCurrencyList().then(response => {
            if (response) {
                this.setState({
                    currenyRates: response
                });

            }

            Config.utilities.loadingFetch();
        });
    }
    render() {
        return (
            <Fragment>
                <BreadCrumb Title={Translate("Currency Settings")} Name={Translate("Currency Settings")} />
                <Card Title="Currency Settings" Description="Customer exchange rate price">
                    <div className="row">
                        {this.state.currenyRates.map((item, index) => (
                            <CurrencyEdit key={index} Data={item} />
                        ))}
                    </div>
                </Card>
            </Fragment>
        )
    }
}